import { Status } from "../types/common";
import {PaymentWay} from "../types/payment";
import {SelectorOption} from "../types/selector";
import React from "react";
import {AdminRoleCategory} from "../types/adminRole";
import {OrderDirection, PageResponse} from "../types/page";

export const camelToSnakeCase = (str: string) => str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);

export const fillZeroTo2Digit = (n: number) => n.toString().padStart(2, "0");

export const hasBothValuesOrBothNoValue = (a: any, b: any) =>
  (a !== 0 && !a && b !== 0 && !b) || ((a === 0 || Boolean(a)) && (b === 0 || Boolean(b)));

export const isFromNumberMoreThanToNumber = (from: number | undefined, to: number | undefined) =>
  from !== undefined && to !== undefined && from > to;
export const LOCALES_STRING = "ko-KR";
export const MINI_MODAL_LINK = "miniModalLink";

export const SELECTOR_AREA = "selectArea";
export const SELECTED_VALUE = "selectedValue";
export const SELECTOR_ARROW = "selectorArrow";

export const numberWithCommas = (x: number) => x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

export const isLoadingStatus = (statusArr: Status[]) => statusArr.some((s) => s === Status.LOADING);

export const getTwoDigitsText = (num: number) => String(num).padStart(2, "0");

export const convertCurrencyUnit = (paymentWay: PaymentWay, t: any) => {
    return paymentWay === PaymentWay.PAYPAL ? t("columns.usAmountUnit") : t("columns.amountUnit");
};

// 국가 선택지 중 필터 처리 함수
export const filterAllowedCountriesCode = (
    {countries, withEmpty}: { countries:SelectorOption[], withEmpty: boolean; }
) => {
    const baseCountryCodes = ['KR', 'US', 'MN', 'NP', 'TW', 'VN'];
    const allowedCountryCodes = withEmpty ? ['', ...baseCountryCodes] : baseCountryCodes;

    return countries.filter(option => allowedCountryCodes.includes(option.value));
};

export const filterAllowedCountriesNumber = (
    {countries, withEmpty}: { countries:SelectorOption[], withEmpty: boolean; }
) => {
    const baseCountryCodes = ['+82', '+1', '+976', '+886', '+84'];
    const allowedCountryCodes = withEmpty ? ['', ...baseCountryCodes] : baseCountryCodes;
    return countries.filter(option => allowedCountryCodes.includes(option.value));
};

// 모달 닫으면서 부모 페이지 새로고침 함수
export const widowOpenerReload = () =>{
    if (window.opener) {
        window.opener.location.reload();
    }
        window.close();
}

// 인풋에서 휴대폰번호 (11자리 + 숫자만) 작성 관리 함수
export const inputCellphoneNumber = (e: React.ChangeEvent<HTMLInputElement>, setValue:(_:string) => void) =>{
    const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');
    if (onlyNumbers.length <= 11) {
        setValue(onlyNumbers);
    }
}

export const isAdmin = localStorage.getItem('role') === AdminRoleCategory.ADMIN_ROOT;

export const isOnlyNumbers = (value: string) => {
    return /^[0-9]+$/.test(value);
}

export const DEFAULT_PAGE_RESPONSE: PageResponse<any> = {
    totalPages: 0,
    totalElements: 0,
    number: 0,
    size: 0,
    numberOfElements: 0,
    first: true,
    last: false,
    empty: true,
    orders: [{
        direction: OrderDirection.ASC,
        property: '',
        ignoreCase: false,
        nullHandling: "NATIVE",
        ascending: false,
        descending: true,
    }],
    pageable: {
        offset: 0,
        sort: {
            sorted: false,
            unsorted: true,
            empty: true,
        },
        pageNumber: 0,
        pageSize: 0,
        paged: true,
        unpaged: false,
    },
    content: [],
};